import {
  TextButton,
  TextButtonProps,
} from 'components/uikit/buttons/TextButton.tsx';
import { ProjectPermissionProps } from '../types/projectPermission.ts';
import { PermissionGate } from '../PermissionGate.tsx';

export const PermissionTextButton = (
  props: TextButtonProps & ProjectPermissionProps,
) => {
  return (
    <PermissionGate {...props}>
      <TextButton {...props} />
    </PermissionGate>
  );
};
